import { EntityAdrContent } from '@backstage-community/plugin-adr';
import plugin from '@backstage-community/plugin-adr/alpha';

// Dotify numbers ADRs with three digits (001-short-title.md); the plugin default
// only accepts four. Keep in step with packages/backend/src/modules/adrSearch.ts.
const adrFilePathFilter = (path: string) =>
  /^(?:.*\/)?\d{3,4}-.+\.md$/.test(path);

export const adrPlugin = plugin.withOverrides({
  extensions: [
    plugin.getExtension('entity-content:adr').override({
      params: {
        loader: async () => (
          <EntityAdrContent filePathFilterFn={adrFilePathFilter} />
        ),
      },
    }),
  ],
});
